import { concat } from "ramda"

export const withAuthor = (relativeUrl) => {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = window.location.protocol + "//" + window.location.host

  return base.concat("/", relativeUrl)
}

export const withAnonymousSharing = (token) =>
  withAuthor(concat("delivery/anonymous-login?session=", token))
